import(/* webpackMode: "eager" */ "/vercel/path0/app/projets/svgBezierCurve/page.jsx")